import { render, staticRenderFns } from "./Die_Why.vue?vue&type=template&id=16f276f5&scoped=true"
import script from "./Die_Why.vue?vue&type=script&lang=js"
export * from "./Die_Why.vue?vue&type=script&lang=js"
import style0 from "./Die_Why.vue?vue&type=style&index=0&id=16f276f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f276f5",
  null
  
)

export default component.exports